import React from 'react';
import { Server, Users } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from "../../../../components/ui/card";
import { Badge } from "../../../../components/ui/badge";
import { Skeleton } from "../../../../components/ui/skeleton";
import { ClusterMetrics, SessionStats } from '../utils/types';
import { MetricsCardProps } from './types';

const ClusterMetricsCards: React.FC<MetricsCardProps> = ({
  clusterMetrics,
  sessionStats,
  isLoading,
  isLoadingSessions
}) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
      <Card>
        <CardHeader className="pb-2">
          <CardTitle className="text-sm font-medium">Total Nodes</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold flex items-center">
            <Server className="h-4 w-4 mr-2 text-primary" />
            {isLoading ? <Skeleton className="h-8 w-16" /> : clusterMetrics.totalNodes}
          </div>
        </CardContent>
      </Card>
      
      <Card>
        <CardHeader className="pb-2">
          <CardTitle className="text-sm font-medium">Total Pods</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold">
            {isLoading ? <Skeleton className="h-8 w-16" /> : clusterMetrics.totalPods}
          </div>
        </CardContent>
      </Card>
      
      <Card>
        <CardHeader className="pb-2">
          <CardTitle className="text-sm font-medium">Running Pods</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold flex items-center">
            <div className="w-2 h-2 rounded-full mr-2 bg-green-500"></div>
            {isLoading ? <Skeleton className="h-8 w-16" /> : clusterMetrics.runningPods}
            <span className="text-sm text-slate-500 ml-2">
              ({isLoading ? '...' : Math.round((clusterMetrics.runningPods / clusterMetrics.totalPods) * 100)}%)
            </span>
          </div>
        </CardContent>
      </Card>
      
      <Card>
        <CardHeader className="pb-2">
          <CardTitle className="text-sm font-medium">Sessions</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold flex items-center">
            <Users className="h-4 w-4 mr-2 text-primary" />
            {isLoadingSessions ? <Skeleton className="h-8 w-16" /> : sessionStats.total}
          </div>
          {!isLoadingSessions && (
            <div className="text-xs text-slate-500 mt-1">
              <div className="flex justify-between">
                <span>Active in Pod:</span> 
                <span className="font-medium text-green-600">{sessionStats.activeInPod}</span>
              </div>
              <div className="flex justify-between">
                <span>Missing Pod:</span> 
                <span className="font-medium text-amber-600">{sessionStats.missingPod}</span>
              </div>
              <div className="flex justify-between">
                <span>No Pod:</span> 
                <span className="font-medium text-red-600">{sessionStats.noPod}</span>
              </div>
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default ClusterMetricsCards; 